import { PiPhone, PiMapPin } from 'react-icons/pi'
import { DescriptionText } from './DescriptionText'

interface DescriptionAndContactInfoProps {
  description?: string
  phone?: string
  address?: string
  googlePlaceUrl?: string
}

export function DescriptionAndContactInfo({
  description,
  phone,
  address,
  googlePlaceUrl,
}: DescriptionAndContactInfoProps) {
  // Don't render anything if no content
  if (!description && !phone && !address) {
    return null
  }

  return (
    <div className="flex flex-col gap-3">
      {/* Description */}
      {description && <DescriptionText text={description} />}

      {/* Contact Info */}
      {phone && (
        <div className="flex items-center gap-1">
          <PiPhone className="w-4 h-4 text-[#6E6E6E]" />
          <a
            href={`tel:${phone}`}
            className="text-xs font-light leading-[18px] text-[#087443] underline"
          >
            {phone}
          </a>
        </div>
      )}
      {address && (
        <div className="flex items-start gap-1">
          <PiMapPin className="w-4 h-4 text-[#6E6E6E] flex-shrink-0 mt-0.5" />
          {googlePlaceUrl ? (
            <a
              href={googlePlaceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-light leading-[18px] text-[#087443] underline"
            >
              {address}
            </a>
          ) : (
            <span className="text-xs font-light leading-[18px] text-[#087443] underline">
              {address}
            </span>
          )}
        </div>
      )}
    </div>
  )
}
